/* eslint-disable */
/// This file is auto generated - do not edit manually
export const FindInStore = 'Website.ProductStoreStock.FindInStore';
export const OnlineOnly = 'Website.ProductStoreStock.OnlineOnly';
export const SoldOutInAllStores = 'Website.ProductStoreStock.SoldOutInAllStores';
export const SoldOutInStores = 'Website.ProductStoreStock.SoldOutInStores';
export const FulfillmentFromStore = 'Website.ProductStoreStock.FulfillmentFromStore';
export const PosStoreStockText = 'Website.ProductStoreStock.PosStoreStockText';
export const NoStoresError = 'Website.ProductStoreStock.NoStoresError';
